import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";

/**--internal-- */
import { plannerIcons } from "UnitPlans/components/plannerIcons";
import { PlannerIconsV2 } from "UnitPlans/components/plannerIconsV2";

/**--relative-- */
import classes from "./PlannerIcon.scss";
import DefaultPlannerIcon from "./DefaultPlannerIcon";
const PlannerIcon = props => {
  const {
    icon,
    label,
    isV2 = false,
    plannerIconCustomStyle,
    size,
    variant,
    hasBackground,
    color,
    isSinglePageAndNewUnitView,
  } = props;
  let iconElement;

  if (_.startsWith(icon, "DEFAULT_PLANNER_ICON")) {
    const backgroundColor = _.lowerCase(_.last(_.split(icon, ":")));
    iconElement = (
      <DefaultPlannerIcon label={label} backgroundColor={backgroundColor} />
    );
  } else {
    iconElement = isV2 ? (
      <PlannerIconsV2
        icon={icon}
        label={label}
        size={size}
        variant={variant}
        hasBackground={hasBackground}
        {...(color ? { color } : {})}
      />
    ) : (
      plannerIcons({ icon })
    );
  }

  return icon && iconElement ? (
    <div
      className={
        isSinglePageAndNewUnitView
          ? classes.iconContainerV2
          : classes.iconContainer
      }
      style={plannerIconCustomStyle}
    >
      {iconElement}
    </div>
  ) : null;
};

PlannerIcon.defaultProps = {
  label: "",
  isV2: false,
  icon: "",
  size: "xx-small",
  variant: "default",
  hasBackground: false,
};

PlannerIcon.propTypes = {
  label: PropTypes.string,
  isV2: PropTypes.bool,
  icon: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  hasBackground: PropTypes.bool,
};

export default PlannerIcon;
PlannerIcon.displayName = "PlannerIcon";
